export default __webpack_public_path__ + "static/media/noEmotionsFaceEmoji.b65ffea9.svg";